import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from 'src/app/shared/shared.module';
import { NewsArticleComponent } from './news-article.component';

@NgModule({
  declarations: [NewsArticleComponent],
  imports: [CommonModule, MediaModule, RouterModule, UrlModule, SlickCarouselModule, I18nModule, SharedModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoArticleComponent: {
          component: NewsArticleComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
})
export class NewsArticleModule {}
